import type { ReactNode } from "react";

import { cn } from "./cn";

/**
 * Floating accent pill, fixed bottom-right above the safe area. `label` is
 * always the accessible name; `text` adds a visible caption next to the icon.
 * `aboveActionBar` lifts it clear of a sticky ActionBar or tab bar.
 */
export function Fab({
  label,
  text,
  onClick,
  children,
  aboveActionBar = false,
}: {
  label: string;
  text?: ReactNode;
  onClick: () => void;
  children: ReactNode;
  aboveActionBar?: boolean;
}) {
  return (
    <button
      type="button"
      aria-label={label}
      data-print="hidden"
      onClick={onClick}
      className={cn(
        "fixed right-gutter z-30 inline-flex h-13 min-w-13 items-center justify-center gap-2 rounded-full",
        text === undefined ? "w-13" : "px-5",
        "bg-accent text-callout font-semibold text-on-accent shadow-fab hover:bg-accent-hover active:bg-accent-active",
        "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus",
        aboveActionBar
          ? "bottom-[calc(env(safe-area-inset-bottom)+var(--tabbar-h)+1rem)]"
          : "bottom-[calc(env(safe-area-inset-bottom)+1rem)]",
      )}
    >
      {children}
      {text !== undefined && <span>{text}</span>}
    </button>
  );
}
